export default "__VITE_ASSET__rCH2AJC9__"